import React, { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import careers_banner from "../Images/career.gif";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import ApplyNowForm from "./ApplyNowForm"; // Import the form component
import SEO from "../components/SEO";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";

export default function Career() {
  const topSectionRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Effect to scroll to top and highlight on page load
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (topSectionRef.current) {
      topSectionRef.current.classList.add("highlight-section");

      const timer = setTimeout(() => {
        if (topSectionRef.current) {
          topSectionRef.current.classList.remove("highlight-section");
        }
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setShowForm(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden";
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedJob(null);
    // Restore body scroll
    document.body.style.overflow = "auto";
  };

  const handleFormSubmit = (formData) => {
    console.log("Application submitted:", formData);
    // Here you can send data to your backend API
    // For now, we'll just show an alert

    toast.success(
      `Thank you ${formData.fullName}! Your application for ${selectedJob.title} has been submitted successfully.`,
    );
    handleCloseForm();
  };

  // Job openings data
  const jobOpenings = [
    {
      id: 1,
      title: "ReactJS Developer - Fresher Entry Level - Internship",
      type: "Internship - Remote/Onsite",
      experience: "Fresher / Entry Level",
      description:
        "Kickstart your career as a ReactJS Intern. Work on live projects, build modern web applications, and learn from industry experts.",
      responsibilities: [
        "Developing new user-facing features using React.js",
        "Building reusable components and front-end libraries",
        "Translating designs and wireframes into high-quality code",
        "Optimizing components for maximum performance",
      ],
      requirements: [
        "Basic understanding of React.js and its core principles",
        "Familiarity with HTML5, CSS3, and JavaScript (ES6)",
        "Knowledge of state management (Redux/Context API) is a plus",
        "Good problem-solving skills and eagerness to learn",
      ],
    },
    {
      id: 2,
      title: "AI Developer - Fresher Entry Level - Internship",
      type: "Internship - Remote/Onsite",
      experience: "4-5+ Years Experience",
      description:
        "Join our AI team to build cutting-edge machine learning models and intelligent systems that solve real business problems.",
      responsibilities: [
        "Designing and implementing machine learning algorithms",
        "Working with large datasets and building predictive models",
        "Integrating AI solutions into production systems",
        "Staying updated with latest AI/ML research and technologies",
      ],
      requirements: [
        "Basic experience in AI/ML development",
        "Strong knowledge of Python and ML libraries (TensorFlow, PyTorch, scikit-learn)",
        "Experience with NLP, Computer Vision, or LLMs",
        "Understanding of data structures, algorithms, and model deployment",
      ],
    },
    {
      id: 3,
      title: "PHP Developer - Fresher Entry Level - Internship",
      type: "Internship - Remote/Onsite",
      experience: "Fresher / Entry Level",
      description:
        "Join our team as a PHP Intern to develop dynamic websites and backend systems for real-world applications.",
      responsibilities: [
        "Writing clean, well-structured PHP code",
        "Working with MySQL databases",
        "Integrating front-end elements with server-side logic",
        "Troubleshooting and debugging existing applications",
      ],
      requirements: [
        "Knowledge of PHP and MySQL",
        "Understanding of HTML, CSS, and JavaScript",
        "Familiarity with any PHP framework (Laravel/CodeIgniter) is a plus",
        "Basic understanding of version control (Git)",
      ],
    },
    {
      id: 4,
      title: "Java Developer - Fresher Entry Level - Internship",
      type: "Internship - Remote/Onsite",
      experience: "Fresher / Entry Level",
      description:
        "Excellent opportunity for aspiring Java developers to gain hands-on experience in building robust enterprise applications.",
      responsibilities: [
        "Developing Java-based applications",
        "Writing well-designed, testable, efficient code",
        "Participating in code reviews and team meetings",
        "Debugging and resolving technical issues",
      ],
      requirements: [
        "Solid understanding of Core Java (OOP, Collections, Multithreading)",
        "Basic knowledge of SQL and databases",
        "Familiarity with IDEs like Eclipse or IntelliJ",
        "Strong analytical and communication skills",
      ],
    },
    {
      id: 5,
      title: "Software Tester - Fresher Entry Level - Internship",
      type: "Internship - Remote/Onsite",
      experience: "Fresher / Entry Level",
      description:
        "Excellent opportunity for aspiring Software Tester to gain hands-on experience in building robust enterprise applications.",
      responsibilities: [
        "Testing Java/Python/PHP/ReactJS -based applications",
        "Understanding well-designed, testable, efficient code",
        "Participating in code reviews and team meetings",
        "Debugging and finding technical issues",
      ],
      requirements: [
        "Solid understanding of Test Cases",
        "Basic knowledge of Postman and Swagger",
        "Familiarity with tools like Jmeter",
        "Strong analytical and communication skills",
      ],
    },
    {
      id: 6,
      title: "Java Developer 3-5 Years Experience",
      type: "Full-time - Remote/Onsite",
      experience: "3-5+ Years Experience",
      description:
        "We are looking for an experienced Java Developer to design and implement high-performance applications and lead technical initiatives.",
      responsibilities: [
        "Designing and developing high-volume, low-latency applications",
        "Writing efficient, reusable, and reliable Java code",
        "Implementing microservices architecture",
        "Mentoring junior developers and conducting code reviews",
      ],
      requirements: [
        "3-5+ years of professional Java development experience",
        "Strong experience with Spring Boot and Hibernate",
        "Experience with RESTful APIs and microservices",
        "Knowledge of cloud platforms (AWS/Azure) is a plus",
      ],
    },
    {
      id: 7,
      title: "ReactJS Developer 3-5 Years Experience",
      type: "Full-time - Remote/Onsite",
      experience: "3-5 Years Experience",
      description:
        "Seeking a skilled ReactJS Developer with 3-5 years of experience to build exceptional user interfaces and lead front-end development.",
      responsibilities: [
        "Developing complex React applications from scratch",
        "Optimizing application for maximum speed and scalability",
        "Collaborating with backend developers and designers",
        "Mentoring team members and establishing best practices",
      ],
      requirements: [
        "3-5 years of experience with React.js",
        "Expertise in Redux, React Router, and modern React hooks",
        "Strong proficiency in JavaScript (ES6+), HTML5, CSS3",
        "Experience with testing frameworks (Jest, React Testing Library)",
      ],
    },
    {
      id: 8,
      title: "AI Developer - 4-5 Years Experience",
      type: "Full-time - Remote/Onsite",
      experience: "4-5+ Years Experience",
      description:
        "Join our AI team to build cutting-edge machine learning models and intelligent systems that solve real business problems.",
      responsibilities: [
        "Designing and implementing machine learning algorithms",
        "Working with large datasets and building predictive models",
        "Integrating AI solutions into production systems",
        "Staying updated with latest AI/ML research and technologies",
      ],
      requirements: [
        "4-5+ years of experience in AI/ML development",
        "Strong knowledge of Python and ML libraries (TensorFlow, PyTorch, scikit-learn)",
        "Experience with NLP, Computer Vision, or LLMs",
        "Understanding of data structures, algorithms, and model deployment",
      ],
    },
  ];

  return (
    <>
      <SEO
        title="Careers at EnteliPro - Tech Job Openings & Internships"
        description="Explore career opportunities and internships at EnteliPro. Join our engineering, AI/ML, and business teams in building next-gen AI ERP and CRM software."
        keywords="EnteliPro Careers, AI Developer Jobs, ReactJS Developer Jobs, Tech Internships, Java Developer Jobs, ERP Careers"
        canonical="https://www.entelipro.com/career"
        ogImage="https://www.entelipro.com/static/media/career.gif"
      />

      <Navbar />

      {/* Hero / Banner Section */}
      <section
        ref={topSectionRef}
        className="w3l-inner-banner-main"
        id="top-section"
      >
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Careers</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image">
                <img
                  src={careers_banner}
                  alt="Careers at EnteliPro - AI ERP and CRM Innovation Team"
                  className="img-responsive"
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  Careers at {project_name} - Join Our Team
                </h1>
                <p className="para">
                  At {project_name}, we believe in nurturing talent and
                  providing opportunities to grow. Join our dynamic team and
                  work on cutting-edge technologies that shape the future of
                  business solutions.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <h5>Why Join Us?</h5>
                    <p className="para">
                      Work on live projects, learn from experienced mentors, and
                      be part of a culture that values innovation and
                      collaboration.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <h5>What We Offer</h5>
                    <p className="para">
                      Competitive compensation, flexible work environment,
                      continuous learning opportunities, and a clear career
                      growth path.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Job Openings Section */}
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work">
          <div className="container">
            <div className="left-text text-center">
              <h3>Current Openings</h3>
              <p className="para">
                Explore exciting opportunities to work with us and take your
                career to the next level.
              </p>
            </div>
            <br />
            <div className="row">
              {jobOpenings.map((job) => (
                <div className="col-lg-6 col-md-12 mb-4" key={job.id}>
                  <div
                    className="job-card"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "10px",
                      padding: "1.5rem",
                      height: "100%",
                      transition: "all 0.3s ease",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      className="job-header"
                      style={{
                        borderBottom: "2px solid #f0f0f0",
                        paddingBottom: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <h4 style={{ color: "#2c3e66", marginBottom: "0.5rem" }}>
                        {job.title}
                      </h4>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor:
                              job.type === "Internship" ? "#e3f2fd" : "#e8f5e9",
                            color:
                              job.type === "Internship" ? "#1565c0" : "#2e7d32",
                            padding: "0.25rem 0.75rem",
                            borderRadius: "20px",
                            fontSize: "0.85rem",
                            fontWeight: "500",
                          }}
                        >
                          {job.type}
                        </span>
                        <span
                          style={{
                            backgroundColor: "#f3e5f5",
                            color: "#6a1b9a",
                            padding: "0.25rem 0.75rem",
                            borderRadius: "20px",
                            fontSize: "0.85rem",
                            fontWeight: "500",
                          }}
                        >
                          {job.experience}
                        </span>
                      </div>
                    </div>
                    <div className="job-body">
                      <p className="para" style={{ marginBottom: "1rem" }}>
                        {job.description}
                      </p>
                      <h5
                        style={{
                          fontSize: "1rem",
                          fontWeight: "600",
                          marginTop: "1rem",
                        }}
                      >
                        Key Responsibilities:
                      </h5>
                      <ul
                        style={{ paddingLeft: "1.2rem", marginBottom: "1rem" }}
                      >
                        {job.responsibilities.map((resp, idx) => (
                          <li
                            key={idx}
                            className="para"
                            style={{ marginBottom: "0.3rem" }}
                          >
                            {resp}
                          </li>
                        ))}
                      </ul>
                      <h5
                        style={{
                          fontSize: "1rem",
                          fontWeight: "600",
                          marginTop: "1rem",
                        }}
                      >
                        Requirements:
                      </h5>
                      <ul
                        style={{
                          paddingLeft: "1.2rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        {job.requirements.map((req, idx) => (
                          <li
                            key={idx}
                            className="para"
                            style={{ marginBottom: "0.3rem" }}
                          >
                            {req}
                          </li>
                        ))}
                      </ul>
                      <button
                        onClick={() => handleApplyClick(job)}
                        className="btn action-button"
                        style={{
                          marginTop: "0.5rem",
                          cursor: "pointer",
                          border: "none",
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Why Work With Us Section */}
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work">
          <div className="container">
            <div className="left-text text-center">
              <h3>Why Work With {project_name}?</h3>
              <p className="para">
                We create an environment where you can thrive both personally
                and professionally.
              </p>
            </div>
            <br />
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Learning & Development</h4>
                  <p className="para">
                    Continuous learning opportunities, certification
                    sponsorships, and access to latest technologies.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Work-Life Balance</h4>
                  <p className="para">
                    Flexible working hours, remote options, and a supportive
                    work culture that respects personal time.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Growth Opportunities</h4>
                  <p className="para">
                    Clear career progression paths, mentorship programs, and
                    opportunities to lead projects.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work">
          <div className="container">
            <div className="left-text text-center">
              <h3>Don't see the right fit?</h3>
              <p className="para">
                We're always looking for talented individuals. Send us your
                resume and we'll keep you in mind for future opportunities.
              </p>
              <Link to="/contact" className="btn action-button mt-lg-5 mt-4">
                Send Your Resume
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {/* Apply Now Form Modal */}
      {showForm && selectedJob && (
        <ApplyNowForm
          jobTitle={selectedJob.title}
          onClose={handleCloseForm}
          onSubmit={handleFormSubmit}
        />
      )}

      <style jsx>{`
        .highlight-section {
          animation: highlightFlash 0.5s ease-in-out 3;
          position: relative;
        }

        @keyframes highlightFlash {
          0% {
            background-color: transparent;
            box-shadow: none;
          }
          50% {
            background-color: rgba(255, 193, 7, 0.3);
            box-shadow: 0 0 20px rgba(255, 193, 7, 0.5);
          }
          100% {
            background-color: transparent;
            box-shadow: none;
          }
        }
      `}</style>
    </>
  );
}
